<template>
  <div>
    <dx-loader v-if="!methodFinished"></dx-loader>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'dx-async',
  props: {
    method: Function,
  },
  data() {
    return {
      methodFinished: false,
    };
  },
  watch: {
    methodFinished(value) {
      if (value) {
        this.$nextTick(() => {
          this.$emit('loaded');
        });
      }
    },
  },
  mounted() {
    this.loadAsync();
  },
  methods: {
    async loadAsync() {
      try {
        await this.method();
      } finally {
        this.methodFinished = true;
      }
    },
  },
};
</script>
